module.exports = __webpack_public_path__ + "static/Sneak-Regular-a9145033d97d0bcbfc44e46282ced777.woff2";